<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <div class="mb25 m-t-25 s_flex_bian_c">
        <a-button type="primary" v-has:salesAreaAdd="()=>{visibleArea=true;areaform={sale_cat_name:'',remark:''}}">
          <PlusOutlined />
          添加销售大区
        </a-button>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="名称" name='sale_cat_name'>
          <a-input v-model:value="search.sale_cat_name" placeholder="销售区名称" />
        </a-form-item>
        <a-form-item label="创建日期" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered  :columns='columns' :data-source='list' class="tableFixBox">
         <template v-slot:dealer_count="{ record }">
            <a-button type="link" v-has:salesAreaDealer="()=>showDealer(record)">{{record.dealer_count}}</a-button>
        </template>
        <template v-slot:action="{ record }">
          <a-button type="primary" v-has:salesAreaEdit="()=>{visibleArea=true;areaId=record.id;areaform=record}" class="m-r-5">编辑</a-button>
          <a-button v-has:salesAreaDel="()=>del(record)" class="m-r-5" v-if="!record.status" danger>删除</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
    <a-modal :keyboard="false" :title="areaId?'修改':'添加'+'销售大区'" centered :footer="null" v-model:visible="visibleArea" destroyOnClose @cancel='formLink={}'>
      <a-form :model='areaform'>
        <a-form-item ref="" label="销售大区" name="sale_cat_name" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" :rules="[{ required: true, message: '请输入销售大区'}]">
          <a-input v-model:value='areaform.sale_cat_name' placeholder="销售大区名称" :maxlength="10"></a-input>
        </a-form-item>
        <a-form-item ref="" label="备注" name="remark" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-textarea v-model:value='areaform.remark' placeholder="备注选填"></a-textarea>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 5 }">
          <a-button type="primary" @click="areaId?edit():save()" :loading="confirmLoadingLink">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
   <a-modal :keyboard="false" title="经销商" centered :footer="null" v-model:visible="dealerShow" destroyOnClose @cancel='formLink={}' :width="1200">
   <a-table :pagination='false' :loading='dealerListLoading' bordered
         :columns='dealerColumns'
        :data-source='dealerList' class="tableFixBox" >
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="dealerSearch.page" :page-size="dealerSearch.limit" :total="dealerSearch.total" @change="dealerPageCurrentChange"
        @showSizeChange="dealerPageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-modal>
  </a-layout>
</template>
<script>
import { DownOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { onMounted, ref } from "vue";
import { iscode } from "@/utils/app";
import {
  getDealerSaleCat,
  createDealerSaleCat,
  updateDealerSaleCat,
  delDealerSaleCat,
} from "@/api/dealer";
import useTableSearch from "@/hooks/useTableSearch";
  import { getDealerList} from "@/api/dealer";
import { message, Modal } from "ant-design-vue";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  sale_cat_name: "",
  start_time: "",
  end_time: "",
};
 let dealerColumns = [
        {
          title: "经销商编号",
          dataIndex: "dealer_sn",
          key: "dealer_sn",
        },
        {
          title: "经销商级别",
          dataIndex: "level_name",
          key: "level_name",
        },
        {
          title: "经销商名称",
          dataIndex: "dealer_name",
          key: "dealer_name",
        },
        {
          title: "手机号码",
          dataIndex: "leader_phone",
          key: "leader_phone",
        },
        {
          title: "负责人",
          dataIndex: "leader_name",
          key: "leader_name",
        },
        {
          title: "上级经销商",
          dataIndex: "parent_dealer_name",
          key: "parent_dealer_name",
        },
        {
          title: "创建日期",
          dataIndex: "create_time",
          key: "create_time",
        },
   
      ];
const columns = [
  {
    title: "销售大区",
    dataIndex: "sale_cat_name",
    key: "sale_cat_name",
  },
  {
    title: "经销商数量",
    dataIndex: "dealer_count",
    key: "dealer_count",
    slots: { customRender: "dealer_count" },
  },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "创建时间",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "最后更新时间",
    dataIndex: "updated_at",
    key: "updated_at",
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
];
export default {
  components: {  PlusOutlined },
  setup(props, ctx) {
    // 列表
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    onMounted(() => {
      tableHoosks.initData(getDealerSaleCat, search.value);
    });
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      tableHoosks.pageSearchChange();
    };
    //  地址 hooks
    const userArea = (api) => {
      const visibleArea = ref(false);
      const confirmLoadingLink = ref(false);
      const areaId = ref("");
      const areaform = ref({
        sale_cat_name: "",
        remark: "",
      });
      const verifyform = () => {
        if (!areaform.value) {
          message.error("请输入销售大区");
          return false;
        }
        return true;
      };
      const save = async () => {
        if (!verifyform()) return;
        confirmLoadingLink.value = true;
        let result = await createDealerSaleCat(areaform.value)
          .then((res) => res.data)
          .catch((error) => error);
        confirmLoadingLink.value = false;
        if (iscode(result, true)) {
        visibleArea.value=false
          // 重置一些数据
          areaform.value = { remark: "", sale_cat_name: "" };
          search.value.page = 1;
          tableHoosks.pageSearchChange();
        }
      };
      const edit = async () => {
        if (!verifyform()) return;
        confirmLoadingLink.value = true;
        let result = await updateDealerSaleCat(areaId.value, {
          ...areaform.value,
          id: areaId,
        })
          .then((res) => res.data)
          .catch((error) => error);
        confirmLoadingLink.value = false;
        if (iscode(result, true)) {
          visibleArea.value=false
          // 重置一些数据
          search.value.page = 1;
          areaform.value = { areaform: "", sale_cat_name: "" };
          areaId.value = null;
          tableHoosks.pageSearchChange();
        }
      };
      const del = (data) => {
        Modal.confirm({
          centered: true,
          content: "确定删除所选销售大区吗",
          onOk: async () => {
            let res = await delDealerSaleCat(data.id, areaId.value).then(
              (res) => res.data
            );
            if (iscode(res, true)) {
              search.value.page = 1;
              tableHoosks.pageSearchChange();
            }
          },
        });
      };
      return {
        visibleArea,
        areaform,
        save,
        edit,
        areaId,
        confirmLoadingLink,
        del,
      };
    };
    const areaHooks = userArea();

    // 查看经销商
    const userCheckDealer=()=>{
      const dealerShow=ref(false)
      const dealerListLoading=ref(false)
      const dealerList=ref()
      const dealerSearch=ref({
        limit:10,
        page:1,
        total:0,
        sale_cat_id:null
      })
      const showDealer=(data)=>{
        dealerSearch.value.sale_cat_id=data.id
        getDealer()
      }
      const dealerPageCurrentChange=(page)=>{
        dealerSearch.value.page = page;
        getDealer();
      }
      const dealerPageSizeChange=(limit)=>{
      dealerSearch.value.page = 1;
        dealerSearch.value.limit = limit;
        getDealer();
      }
      var getDealer=async (data)=>{
        dealerShow.value=true
        dealerListLoading.value=true
        let reslut=await getDealerList(dealerSearch.value).then(res=>res.data).catch(error=>error)
        dealerListLoading.value=false
        dealerList.value = reslut.data.list;
        dealerSearch.value.total = reslut.data.total;
      }

      return{
        dealerShow,
        dealerListLoading,
        dealerSearch,
        showDealer,
        dealerPageCurrentChange,
        dealerPageSizeChange,
        dealerList
      }
    }
    const dealerHooks=userCheckDealer()
    return {
      ...tableHoosks,
      columns,
      ...areaHooks,
      onChange,
      dealerColumns,
      ...dealerHooks
    };
  },
};
</script>